export default __webpack_public_path__ + "static/media/user.4ccc3d12.svg";